import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { RELATORIOS_MAPEAMENTO } from "./relatorios";
import { toast } from "react-toastify";
import { PostRelatorioAcesso } from "../../../../data/services";

const AcessoModal = ({ onClose, onSuccess }) => {
  const [login, setLogin] = useState("");
  const [selected, setSelected] = useState("");

  const handleSubmit = async () => {
    if (!login || !selected) {
      toast.warning("Preencha todos os campos!");
      return;
    }
    try {
      const res = await PostRelatorioAcesso(login, selected);

      if (res.status === 201 || res.data.success) {
        toast.success("Acesso cadastrado com sucesso!");
        onSuccess();
        onClose();
      } else {
        toast.error(res.data.message || "Erro ao cadastrar acesso.");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Usuário não encontrado ou erro no servidor."
      );
    }
  };

  return (
    <Overlay>
      <ModalContainer>
        <Title>Adicionar Acesso</Title>
        <Label>Matrícula</Label>
        <Input
          type="text"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          placeholder="Ex: 00272281"
        />

        <Label>Relatório</Label>
        <Select value={selected} onChange={(e) => setSelected(e.target.value)}>
          <option value="">Selecione um relatório...</option>
          {Object.entries(RELATORIOS_MAPEAMENTO).map(([arquivo, nomeAmigavel]) => (
              <option key={arquivo} value={arquivo}>
                {nomeAmigavel}
              </option>
            ))}
        </Select>

        <ButtonRow>
          <CancelButton onClick={onClose}>Cancelar</CancelButton>
          <ConfirmButton onClick={handleSubmit}>Cadastrar</ConfirmButton>
        </ButtonRow>
      </ModalContainer>
    </Overlay>
  );
};

export default AcessoModal;


const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  animation: ${fadeIn} 0.3s ease;
`;

const ModalContainer = styled.div`
  background: #fff;
  border-radius: 14px;
  padding: 28px;
  width: 420px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  animation: ${fadeIn} 0.25s ease;
`;

const Title = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 1.2rem;
`;

const Label = styled.label`
  display: block;
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 1.3rem;
  &:focus {
    outline: none;
    border-color: #8fd19e;
    box-shadow: 0 0 0 2px rgba(143, 209, 158, 0.3);
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 1.4rem;
  font-size: 1.3rem;
  &:focus {
    outline: none;
    border-color: #8fd19e;
    box-shadow: 0 0 0 2px rgba(143, 209, 158, 0.3);
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const CancelButton = styled.button`
  background: #f2f2f2;
  border: none;
  color: #444;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    background: #e0e0e0;
  }
`;

const ConfirmButton = styled.button`
  background: linear-gradient(135deg, #8fd19e, #a8e6a1);
  border: none;
  color: #0f5132;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background: linear-gradient(135deg, #7acb91, #9bdf95);
  }
`;
